import { render, staticRenderFns } from "./ToolboxTalksComponent.vue?vue&type=template&id=32854ffc&scoped=true&"
import script from "./ToolboxTalksComponent.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalksComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolboxTalksComponent.vue?vue&type=style&index=0&id=32854ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32854ffc",
  null
  
)

export default component.exports